exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-020661ab],th[data-v-020661ab]{width:120px}", ""]);

// exports
